import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AppPermission } from '@app/shared/services/apps/apps.service';

@Component({
  standalone: false,
  selector: 'sbnb-craftedstays',
  template: `
    <sbnb-apps-detail-page
      vendorCode="craftedstays"
      name="CraftedStays"
      logoTile="/assets/images/apps/craftedstays.png"
      builtBy="CraftedStays"
      builtByLink="https://craftedstays.co/"
      [categories]="['Direct bookings']"
      [permissions]="[AppPermission.propertyRead, AppPermission.reservationRead, AppPermission.calendarRead]"
      email="support@craftedstays.co"
      [helpArticles]="[
        {
          id: '9250518',
          title: 'Connecting Hospitable with CraftedStays'
        }
      ]">
      <ng-container description>
        <p>
          CraftedStays is a direct booking platform made to simplify direct bookings. Don't just have any website, have
          a website that you love and that converts! Integrated with Hospitable, CraftedStays is able to create a
          beautiful integrated site in as little as 15-minutes. Choose from a library of beautifully crafted templates.
          Create your own custom pages to help showcase all the things you provide. With CraftedStays you're able to
          create a well functioning website that drives more bookings. Start winning in direct bookings today.
        </p>

        <p><strong>Features</strong></p>
        <ul class="list list__looser">
          <li>Features Built-in Short-Term-Rental Templates</li>
          <li>Custom branding</li>
          <li>Automatically sync your property with hospitable</li>
          <li>Review showcase</li>
          <li>Seamless booking experience, no separate site</li>
          <li>Hosted URL provided</li>
          <li>Use your own custom domain at no extra cost</li>
          <li>Metrics to monitor website traffic performance</li>
        </ul>


        <div style="position: relative; padding-bottom: 56.25%; height: 0">
          <iframe
            src="https://www.youtube.com/embed/cREFYefxRYA"
            frameborder="0"
            allowfullscreen
            style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"></iframe>
        </div>
      </ng-container>
    </sbnb-apps-detail-page>
  `,
  styleUrls: ['./craftedstays.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CraftedstaysComponent {
  AppPermission = AppPermission;
}
